/** Collection cover corners: radius = side ÷ 3 (see COLLECTION_COVER_SPEC). */
export const COLLECTION_COVER_BORDER_RADIUS = '33.333%';
